import { Component, Prop, Vue } from 'vue-property-decorator';
import { GameIdentity, IPlaySoundArgs } from '@/components/game/_domain/models';
import { SERVICE_IDENTIFIERS } from '@/app-modules/_ioc/service-identifiers';
import DefaultGameViewComponent from '@/components/game/implementations/_default/game-view';
import Bingo75GameViewComponent from '@/components/game/implementations/uk/bingo-75/game-view';
import SEBingo75GameViewComponent from '@/components/game/implementations/se/bingo-75/game-view';
import ITBingo75GameViewComponent from '@/components/game/implementations/it/bingo-75/game-view';
import HamsterRaceGameViewComponent from '@/components/game/implementations/uk/hamster-race/game-view';
import Bingo40GameViewComponent from '@/components/game/implementations/uk/bingo-40/game-view';
import Bingo60GameViewComponent from '@/components/game/implementations/uk/bingo-60/game-view';
import RollerCoasterGameViewComponent from '@/components/game/implementations/uk/roller-coaster/game-view';
import TombolaRouletteGameViewComponent from '@/components/game/implementations/uk/tombola-roulette/game-view';
import PotionGameViewComponent from '@/components/game/implementations/uk/potion/game-view';
import TheMachineGameViewComponent from '@/components/game/implementations/uk/the-machine/game-view';
import CincoGameViewComponent from '@/components/game/implementations/uk/cinco/game-view';
import HexGameViewComponent from '@/components/game/implementations/uk/hex/game-view';
import BritainsBiggestBingoGameViewComponent from '@/components/game/implementations/uk/britains-biggest-bingo/game-view';
import BubbleBingoGameViewComponent from '@/components/game/implementations/uk/bubble-bingo/game-view';
import ReelBingoGameViewComponent from '@/components/game/implementations/uk/reel-bingo/game-view';
import WordSearchGameViewComponent from '@/components/game/implementations/uk/wordsearch/game-view';
import DondBingoGameViewComponent from '@/components/game/implementations/uk/dondbingo/game-view';
import TombolaBaseComponent from '@/components/base/base.component';
import { IGameController } from '@/components/game/_domain/models/game-controller';
import { IGameControllerFactory } from '@/components/game/_domain/server/_factory';
import { ISoundService } from '@/app-modules/sound-service';
import { UserPreferences } from '@/app-modules/store/modules/user-preferences';
import { container } from '@/app-modules/_ioc';
import { IPersistedStore } from '@/app-modules/store/persisted-store';


@Component({
  name: 'GameComponent',
  components: {
    defaultGameView: DefaultGameViewComponent,
    bingo75GameView: Bingo75GameViewComponent,
    seBingo75GameView: SEBingo75GameViewComponent,
    itBingo75GameView: ITBingo75GameViewComponent,
    hamsterraceGameView: HamsterRaceGameViewComponent,
    bingo40GameView: Bingo40GameViewComponent,
    bingo60GameView: Bingo60GameViewComponent,
    rollercoasterGameView: RollerCoasterGameViewComponent,
    tombolarouletteGameView: TombolaRouletteGameViewComponent,
    potionGameView: PotionGameViewComponent,
    themachineGameView: TheMachineGameViewComponent,
    cincoGameView: CincoGameViewComponent,
    hexGameView: HexGameViewComponent,
    bubblebingoGameView: BubbleBingoGameViewComponent,
    reelbingoGameView: ReelBingoGameViewComponent,
    britainsbiggestbingoGameView: BritainsBiggestBingoGameViewComponent,
    wordsearchGameView: WordSearchGameViewComponent,
    dondbingoGameView: DondBingoGameViewComponent
  }
})
export default class GameComponent extends TombolaBaseComponent {
  @Prop() public modalGuid: string;
  @Prop() public gameName: string;
  @Prop() public id: number;
  @Prop() public clubName: string;
  private gameController: IGameController = null;
  private gameViewComponentName: string = null;
  private gameViewClasses: { [key: string]: boolean } = {};
  private persistedStore = container.get(SERVICE_IDENTIFIERS.IPersistedStore) as IPersistedStore;
  private userPreferences: UserPreferences = this.persistedStore.Get(UserPreferences);

  private get gameControllerFactory(): IGameControllerFactory {
    return this.$container.get(SERVICE_IDENTIFIERS.IGameControllerFactory);
  }

  private mounted() {
    const gameIdentity = new GameIdentity(this.gameName, this.clubName, this.id);
    this.gameController = this.gameControllerFactory.getControllerForGame(gameIdentity);
    this.initialiseGameViewComponent();
    this.updateGameViewClasses();

    Vue.nextTick(() => {
      this.gameController.onPlaySound(this.handlePlaySound);
    });
  }

  private beforeDestroy() {
    this.gameController.dispose();
  }

  private get soundService(): ISoundService {
    return this.$container.get(SERVICE_IDENTIFIERS.ISoundService) as ISoundService;
  }

  private initialiseGameViewComponent() {
    const game = this.gameController.getGame();
    const gameConfiguration = game.gameConfiguration;
    // TODO: SE B75 and NL B75 is a special child, we need a better way of handling these cases
    if ((this.userPreferences.country.toLowerCase() === 'se' || this.userPreferences.country.toLowerCase() === 'nl') && this.gameName === 'Bingo 75') {
      this.gameViewComponentName = 'seBingo75GameView';
    }
    else if ((this.userPreferences.country.toLowerCase() === 'it') && this.gameName === 'Bingo 75') {
      // TODO: The whole system for loading in games with the name as a uk version needs to be rewritten, this is a tempory patch
      this.gameViewComponentName = 'itBingo75GameView';
    }
    else {
      this.gameViewComponentName = this.$options.components[gameConfiguration.gameViewComponentName] ? gameConfiguration.gameViewComponentName : 'defaultGameView';
    }
  }

  private handleGameViewResized(): void {
    this.updateGameViewClasses();
  }

  private updateGameViewClasses(): void {
    this.gameViewClasses = {
      'game-view-responsive': this.$el.offsetHeight < 250
    };
  }

  protected handlePlaySound(eventArgs: IPlaySoundArgs): void {
    if (this.$tombolaStore.Get(UserPreferences).notificationSound) {
      const modal = this.$modalManager.getModal(this.modalGuid);
      if (!modal.isMinimised) {
        this.soundService.play(eventArgs.sound);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/game.component.ts